import { render, staticRenderFns } from "./AppBackTop.vue?vue&type=template&id=4fe18fc2"
import script from "./AppBackTop.vue?vue&type=script&lang=js"
export * from "./AppBackTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports